import React, { useCallback, useState } from "react";
import ContentLoader from "react-content-loader";

const ROW_HEIGHT = 48;
const ROWS = 8;

// Skeleton that mirrors the catalog list: a card surface with rows of
// [thumbnail] [title] ........ [revenue].
const ContentTreeLoaderTemplate = (props) => {
    const [loaderWidth, setLoaderWidth] = useState(0);

    const ref = useCallback((node) => {
        if (node !== null) setLoaderWidth(node.getBoundingClientRect().width);
    }, []);

    const loaderHeight = ROWS * ROW_HEIGHT;

    return (
        <div className="c-card--primary u-padd--none" ref={ref}>
            <ContentLoader
                speed={2}
                width={loaderWidth}
                height={loaderHeight}
                viewBox={`0 0 ${loaderWidth} ${loaderHeight}`}
                backgroundColor="#262729"
                foregroundColor="#2b2b2b"
                {...props}
            >
                {Array.from({ length: ROWS }).map((_, i) => {
                    const y = i * ROW_HEIGHT;
                    // Indent every other row a little to hint the collection/album hierarchy.
                    const indent = i % 2 === 0 ? 16 : 38;
                    const titleWidth = i % 2 === 0 ? 180 : 140;
                    return (
                        <React.Fragment key={i}>
                            <rect x={indent} y={y + 7} rx="6" ry="6" width="34" height="34" />
                            <rect x={indent + 46} y={y + 18} rx="6" ry="6" width={titleWidth} height="12" />
                            {loaderWidth > 0 && (
                                <rect x={loaderWidth - 64} y={y + 18} rx="6" ry="6" width="48" height="12" />
                            )}
                        </React.Fragment>
                    );
                })}
            </ContentLoader>
        </div>
    );
};

export default ContentTreeLoaderTemplate;
